import { createContext } from "react";

const SettingMultiWebContext = createContext({});

export default SettingMultiWebContext;
